export function detectCanvasSupport() {
    const offscreenSupported = typeof OffscreenCanvas !== "undefined";
    const imageBitmapSupported = typeof createImageBitmap === "function";

    return {
        offscreenSupported,
        imageBitmapSupported,
        strategy: offscreenSupported ? "offscreen" : "fallback"
    };
}
